import { EImportEntity } from '../importer/model';
import { importReducer } from '../importer/reducer';

export const staticRatesAvailabilityImport = importReducer(EImportEntity.STATIC_RATES_AVAILABILITY);
